import { REFERENCE, collectBcProductIds } from './reference.js'
import { mergeCatalog } from './merge.js'

// The storefront products collection. Callers pass the existing Mango helper.
// This module never names a host.
export function catalogQuery(ids) {
	return {
		search: { bcId: { $in: ids } },
		limit: Math.max(ids.length, 1),
		depthLimit: 1,
	}
}

export async function loadWaterBirthCatalog(fetchProducts, reference = REFERENCE) {
	const ids = collectBcProductIds(reference)
	try {
		const products = await fetchProducts(ids)
		return mergeCatalog(reference, Array.isArray(products) ? products : [], { loaded: true })
	} catch {
		return mergeCatalog(reference, [], { loaded: false })
	}
}
